// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".LanguageSettings__languageSettings___1hnJE{padding:18px}.LanguageSettings__toggle___14J-a{margin-bottom:0}.LanguageSettings__table___1iAM7{font-size:14px}.LanguageSettings__note___1lx11{font-style:italic}\n", ""]);
// Exports
exports.locals = {
	"languageSettings": "LanguageSettings__languageSettings___1hnJE",
	"toggle": "LanguageSettings__toggle___14J-a",
	"table": "LanguageSettings__table___1iAM7",
	"note": "LanguageSettings__note___1lx11"
};
module.exports = exports;
